<template>
  <StatisticsTemplate>
    <template slot="title"> Access by Preference Device</template>
    <template slot="excel">
      <a
        @click="downExcel()"
        href="javascript:void(0)"
        class="btn btn-secondary btn-md m-1"
        >{{ $t("common.excelDownload") }}</a
      >
    </template>
    <template slot="filter">
      <tr>
        <th>{{ $t("common.period") }}</th>
        <td>
          <date-picker
            v-model="startDate"
            placeholder="Select date"
            @change="selectDate"
            :disabled-date="disabledRange"
          ></date-picker>
          ~
          <date-picker
            v-model="endDate"
            placeholder="Select date"
            @change="selectDate"
            :disabled-date="disabledRange"
          ></date-picker>
        </td>
      </tr>
    </template>
    <template slot="graph">
      <ChartTemplate id="chartTemplate" ref="chartTemplate" />
    </template>
  </StatisticsTemplate>
</template>

<script>
import StatisticsTemplate from "@/components/management/statistics/common/StatisticsTemplate";
import ChartTemplate from "@/components/management/statistics/bypreferencedevice/ChartTemplate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { accessByPreferenceDeviceExcel } from "@/api/statisticsV2";
export default {
  components: {
    ChartTemplate,
    StatisticsTemplate,
    DatePicker,
  },
  data() {
    return {
      startDate: "",
      endDate: new Date(Date.now()),
      form: {
        startDate: "",
        endDate: "",
      },
    };
  },
  async created() {
    await this.setPeriodSelect();
    this.setStatistics();
  },
  methods: {
    setPeriodSelect() {
      var now = new Date();
      var thisYear = now.getFullYear();
      this.startDate = new Date(thisYear + "-01-01 07:00:00");
      this.endDate = new Date(Date.now());
      this.setDateFormat();
    },
    disabledRange(date) {
      return date < new Date("2020", "12", "01") || date > new Date(Date.now());
    },
    setDateFormat() {
      let startTmpYear = this.startDate.getFullYear();
      let startTmpMonth = this.startDate.getMonth() + 1;
      let startTmpDate = this.startDate.getDate();
      let startResult =
        startTmpYear +
        "" +
        (startTmpMonth.toString().length == 1 ? "0" + startTmpMonth : startTmpMonth) +
        "" +
        (startTmpDate.toString().length == 1 ? "0" + startTmpDate : startTmpDate);

      let endTmpYear = this.endDate.getFullYear();
      let endTmpMonth = this.endDate.getMonth() + 1;
      let endTmpDate = this.endDate.getDate();
      let endResult =
        endTmpYear +
        "" +
        (endTmpMonth.toString().length == 1 ? "0" + endTmpMonth : endTmpMonth) +
        "" +
        (endTmpDate.toString().length == 1 ? "0" + endTmpDate : endTmpDate);
      this.form.startDate = startResult;
      this.form.endDate = endResult;
    },
    selectDate() {
      if (this.startDate > this.endDate) {
        alert(this.$t("alert.checkDate"));
        this.endDate = this.startDate;
        return;
      }
      this.setDateFormat();
      this.setStatistics();
    },
    async setStatistics() {
      await this.$refs.chartTemplate.getData(this.form.startDate, this.form.endDate);
    },
    async downExcel() {
      let loader = this.$loading.show({});
      let result = await accessByPreferenceDeviceExcel(
        this.form.startDate,
        this.form.endDate
      );
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "AccessByPreferenceDevice.xls";
      link.click();
      window.URL.revokeObjectURL(url);
      loader.hide();
    },
  },
};
</script>

<style></style>
